var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  require("!!vue-style-loader!css-loader?importLoaders=1?{\"minimize\":false,\"sourceMap\":false}!../../../vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-2c123d7f\",\"scoped\":true,\"hasInlineConfig\":false}!../../../vue-loader/lib/selector?type=styles&index=0!../../../webpack-px-to-rem/index.js??ref--4!./Submenu.vue")
  require("!!vue-style-loader!css-loader?importLoaders=1?{\"minimize\":false,\"sourceMap\":false}!../../../vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-2c123d7f\",\"scoped\":false,\"hasInlineConfig\":false}!../../../vue-loader/lib/selector?type=styles&index=1!../../../webpack-px-to-rem/index.js??ref--4!./Submenu.vue")
}
var Component = require("!../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../vue-loader/lib/selector?type=script&index=0!../../../webpack-px-to-rem/index.js??ref--4!./Submenu.vue"),
  /* template */
  require("!!../../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-2c123d7f\",\"hasScoped\":true}!../../../vue-loader/lib/selector?type=template&index=0!../../../webpack-px-to-rem/index.js??ref--4!./Submenu.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2c123d7f",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/var/www/html/node_modules/vue-contextmenujs/src/components/Submenu.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] Submenu.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2c123d7f", Component.options)
  } else {
    hotAPI.reload("data-v-2c123d7f", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-contextmenujs/src/components/Submenu.vue
// module id = 401
// module chunks = 32